import { LottieLight } from "lottie-react";
import type { FC } from "react";
import successAnimation from "../../../assets/animations/success-check.json";

export const CheckMark: FC = () => <LottieLight src={successAnimation} autoplay loop={false} style={{ width: 120, height: 120 }} />;
